import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AdminModeContextType {
  adminModeEnabled: boolean;
  setAdminModeEnabled: (enabled: boolean) => void;
}

const AdminModeContext = createContext<AdminModeContextType | undefined>(undefined);

export const AdminModeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [adminModeEnabled, setAdminModeEnabled] = useState(false);

  return (
    <AdminModeContext.Provider value={{ adminModeEnabled, setAdminModeEnabled }}>
      {children}
    </AdminModeContext.Provider>
  );
};

export const useAdminMode = () => {
  const context = useContext(AdminModeContext);
  if (!context) {
    throw new Error('useAdminMode must be used within AdminModeProvider');
  }
  return context;
};
